import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from 'react';
import PropTypes from 'prop-types';
import { InputField } from '../InputField';
import { Checkbox } from '../Checkbox';
import { Toggle } from '../Toggle';
import { DatePicker } from '../Calendar';
import { RadioBox } from '../RadioBox';
import { RadioButton } from '../RadioButton';
import { RadioSwatch } from '../RadioSwatch';
var propTypes = {
  type: PropTypes.oneOf(['checkbox', 'toggle', 'datePicker', 'radioBox', 'radioSwatch', 'radioButton', 'radio', 'text', 'number', 'calendar'])
};
var defaultProps = {
  type: 'text'
};
/**
 * @ignore
 */

var Input = function Input(_ref) {
  var type = _ref.type,
      props = _objectWithoutProperties(_ref, ["type"]);

  switch (type) {
    case 'checkbox':
      return /*#__PURE__*/React.createElement(Checkbox, props);

    case 'toggle':
      return /*#__PURE__*/React.createElement(Toggle, props);

    case 'calendar':
      return /*#__PURE__*/React.createElement(DatePicker, props);

    case 'radioBox':
      return /*#__PURE__*/React.createElement(RadioBox, props);

    case 'radioButton':
    case 'radio':
      return /*#__PURE__*/React.createElement(RadioButton, props);

    case 'radioSwatch':
      return /*#__PURE__*/React.createElement(RadioSwatch, props);

    case 'number':
    case 'text':
      return /*#__PURE__*/React.createElement(InputField, _extends({
        type: type
      }, props));

    default:
      console.warn('Warning: Native input type ' + type + ' is not supported');
      return /*#__PURE__*/React.createElement(InputField, _extends({
        type: "text"
      }, props));
  }
};

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;
export default Input;